import React, { forwardRef } from "react";
import { Icon, Typography } from "@mui/material";
import { capitalize } from "@fac/utils";
import classNames from "classnames";
import ChatMessageProps from "./ChatMessage.type";
import ChatMessageRoot, { ChatMessageContentContainer, ChatMessageContentWrapper, ChatMessageHeader } from "./ChatMessage.styles";

export const ChatMessage = React.memo<ChatMessageProps>(
    forwardRef<HTMLDivElement, ChatMessageProps>(
        (
            {
                content,
                renderMessage,
                titleIcon,
                title,
                disableHeader = true,
                direction = "left",
                variant = "standard",
                ...props
            },
            ref,
        ) => (
            <ChatMessageRoot
                className={classNames(
                    "FacChatMessage-root",
                    `Fac${capitalize(variant)}ChatMessage-root`,
                    `Fac${capitalize(direction)}ChatMessage-root`,
                )}
                variant={variant}
                ref={ref}
                {...props}
            >
                {!disableHeader && (
                    <ChatMessageHeader
                        className={classNames(
                            "FacChatMessage-header",
                            `Fac${capitalize(variant)}ChatMessage-header`,
                            `Fac${capitalize(direction)}ChatMessage-header`,
                        )}
                    >
                        {titleIcon && <Icon>{titleIcon}</Icon>}
                        <Typography>{title}</Typography>
                    </ChatMessageHeader>
                )}
                <ChatMessageContentWrapper
                    className={classNames(
                        "FacChatMessage-wrapper",
                        `Fac${capitalize(direction)}ChatMessage-wrapper`,
                    )}
                >
                    <ChatMessageContentContainer
                        className={classNames(
                            "FacChatMessage-container",
                            `Fac${capitalize(variant)}ChatMessage-container`,
                            `Fac${capitalize(direction)}ChatMessage-container`,
                        )}
                    >
                        {renderMessage ? renderMessage({
                            content,
                            renderMessage,
                            titleIcon,
                            title,
                            disableHeader,
                            direction,
                            variant,
                            ...props,
                        }) : (
                            <Typography variant="body2">
                                { content }
                            </Typography>
                        )}
                    </ChatMessageContentContainer>
                </ChatMessageContentWrapper>
            </ChatMessageRoot>
        ),
    ),
);

export default ChatMessage;
